import { useRef, useState } from "react";
import "../css/CuSuggestionBox.css";
import CuInput from "../../all-patient/components/CuInput";

const CuSuggestionBox = ({
  placeholder = "",
  type = "text",
  options = [],
  required = false,
  loading = false,
  position = "calc(50% + 0px)",
  value = "",
  label,
  handleSelectOption = () => {},
  renderKey,
  searchable = false,
  disabled = false,
  setSearchInput = () => {},
  searchInput = "",
  onChange = () => {},
  add,
}) => {
  const [selectedItem, setSelectedItem] = useState(0);
  //   const [searchInput, setSearchInput] = useState("");
  const optionsRef = useRef([]);
  const optionsContainerRef = useRef(null);

  const handleKeyEvents = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
    }
    if (e.key === "ArrowDown" && selectedItem < options?.length - 1) {
      e.preventDefault();
      setSelectedItem((prev) => prev + 1);
      const selectedOptionElement = optionsRef.current[selectedItem + 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          optionsContainerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedItem > 0) {
      e.preventDefault();
      setSelectedItem((prev) => prev - 1);
      const selectedOptionElement = optionsRef.current[selectedItem - 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          optionsContainerRef.current.scrollTop -=
            containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      optionsRef.current[selectedItem].click();
      setSelectedItem(0);
    }
  };

  const handleSearch = (e) => {
    if (searchable) {
      setSearchInput(e.target.value);
    }
    onChange(e.target.value);
  };

  return (
    <div className="relative">
      <CuInput
        type={type}
        placeholder={placeholder}
        value={value}
        // dropdown={true}
        disabled={disabled}
        onChange={handleSearch}
        onKeyDown={handleKeyEvents}
        label={label}
        required={required}
        loading={loading}
        position={position}
      />
      {searchInput?.length > 0 && options?.length > 0 && (
        <div className="cu-suggestion-box-list" ref={optionsContainerRef}>
          {options?.map((option, opidx) => {
            return (
              <div
                className={`cu-suggestion-box-list-item ${
                  selectedItem === opidx
                    ? "cu-suggestion-box-list-item-active"
                    : ""
                }`}
                key={opidx}
                onClick={() => handleSelectOption(option)}
                ref={(el) => (optionsRef.current[opidx] = el)}
              >
                {option[renderKey]}
              </div>
            );
          })}
        </div>
      )}
      {searchInput?.length > 0 && options?.length === 0 && (
        <div className="cu-suggestion-box-list">
          <div className="cu-suggestion-box-list-item text-gray-400">
            {loading ? "Loading..." : "No Data Found"}
          </div>
          {!loading && add && (
            <div
              className="cu-suggestion-box-list-item text-gray-500"
              onClick={() => {
                handleSelectOption({ [renderKey]: searchInput }, label);
                setSearchInput("");
              }}
            >
              Add {searchInput}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CuSuggestionBox;
